import React from 'react';
import { BenefitLabel } from '../common/BenefitLabel';
const LIMIT_DEFAULT = 2;

export function ProductCardTags({badges, limit = LIMIT_DEFAULT}) {
  if(!badges || (!badges.benefits?.length && !badges[0]?.TagId)) { return null; }
  let displayedBadges = [];
  if (badges.benefits?.length) {
    displayedBadges = badges.benefits.slice(0, limit);
  } else if (badges[0]?.TagId) {
    displayedBadges = badges.slice(0, limit).map(tag => ({
      title: tag.TagLabel,
      url: `${document.body.getAttribute('data-homepage')}/products`,
      colour: tag.TagColour,
      path: tag.TagId,
    }));
  }
  return (
      <div className="pdp__badges-container">
        {displayedBadges.map((badge, index) => (
          <BenefitLabel benefit={badge} key={index}/>
        ))}
      </div>
  );
}
